var render = function render(){var _vm=this,_c=_vm._self._c;return _c('road-book-edit',{ref:"roadBookEdit"})
}
var staticRenderFns = []

export { render, staticRenderFns }